export const CURRENT_USER = "CURRENT_USER";
export const ORDER_NOW = "ORDER_NOW";
export const PARTNERSHIP = "PARTNERSHIP";
export const DEFAULT_STOREID = 1;